module.exports = __webpack_public_path__ + "img/whatsapp.9eac1925.svg";